import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// LIVE FIREBASE SET UP
const firebaseConfig = {
  apiKey: "AIzaSyC5FAN8Kkji60y73UAzKrC8D5UBKcCMsh4",
  authDomain: "vow-branding.firebaseapp.com",
  databaseURL:
    "https://vow-branding-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "vow-branding",
  storageBucket: "vow-branding.firebasestorage.app",
  messagingSenderId: "93133153662",
  appId: "1:93133153662:web:bc25ac79919572eeed7f2f",
  measurementId: "G-MN7ZPW5LG4",
};

// LOCAL FIREBASE SET UP
// const firebaseConfig = {
//   apiKey: "AIzaSyAqsOhw8NAkqOSVd543DgVaVsvJyMQTS2I",
//   authDomain: "vowtesting-c61f7.firebaseapp.com",
//   databaseURL: "https://vowtesting-c61f7-default-rtdb.firebaseio.com",//Local FIREBASE URL
//   projectId: "vowtesting-c61f7",
//   storageBucket: "vowtesting-c61f7.firebasestorage.app",
//   measurementId: "G-MHHH8GDFG1",
//   appId: "1:525836525443:web:476e74f7777c9368daa0b6",
// };

const app = initializeApp(firebaseConfig);

export const database = getDatabase(app);
